import { useEffect, useState } from "react";
import screenfull from "screenfull";

export interface FullscreenProps {
    targetId: string;
}

/** 指定节点全屏控制，保留旧版 targetId 和状态同步行为。 */
export function Fullscreen({ targetId }: FullscreenProps) {
    const [isFullScreen, setIsFullScreen] = useState(false);
    useEffect(() => {
        if (!screenfull.isEnabled) return undefined;
        const sync = () => setIsFullScreen(screenfull.isFullscreen);
        screenfull.on("change", sync);
        return () => screenfull.off("change", sync);
    }, []);
    return (
        <button
            type="button"
            className="fullscreen-icon"
            aria-label={isFullScreen ? "退出全屏" : "进入全屏"}
            onClick={() => {
                const target = document.getElementById(targetId);
                if (target && screenfull.isEnabled) void screenfull.toggle(target);
            }}
        >
            {isFullScreen ? "收起" : "全屏"}
        </button>
    );
}

export default Fullscreen;
